import { SpellCheckTextbox } from './SpellCheckTextbox';

/**
 * Hide spellcheck underlines for all textboxes on the canvas during export.
 * Hiding drops the textbox cache, so textboxes without underlines are left
 * alone: their cache stays valid for the export and the next render.
 * @param {fabric.Canvas} canvas - The fabric canvas instance
 * @returns {Function} Function to restore spellcheck visibility
 */
export const hideSpellCheckForExport = (canvas) => {
  if (!canvas) {
    canvas = window.canvas;
  }

  if (typeof canvas.getObjects !== 'function') {
    return () => {};
  }

  const restoreFunctions = [];

  // Find the SpellCheckTextbox instances with underlines and hide them
  canvas.getObjects().forEach((obj) => {
    if (
      obj instanceof SpellCheckTextbox &&
      obj.hasSpellCheckUnderlinesToHide()
    ) {
      const restoreFn = obj.hideSpellCheckForExport();
      restoreFunctions.push(restoreFn);
    }
  });

  // Return a function that restores all spellcheck states
  return () => {
    restoreFunctions.forEach((restore) => restore());
  };
};
